var _defs, _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "856049691c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 590 L 810 590 L 810 691.707031 L 0 691.707031 Z M 0 590 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M 759.375 354.371094 L 50.625 354.371094 C 22.664062 354.371094 0 377.035156 0 404.996094 C 0 432.957031 22.664062 455.621094 50.625 455.621094 L 759.375 455.621094 C 787.335938 455.621094 810 432.957031 810 404.996094 C 810 377.035156 787.335938 354.371094 759.375 354.371094 Z M 759.375 354.371094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#856049691c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M 759.375 590.621094 L 50.625 590.621094 C 22.664062 590.621094 0 613.285156 0 641.246094 C 0 669.207031 22.664062 691.871094 50.625 691.871094 L 759.375 691.871094 C 787.335938 691.871094 810 669.207031 810 641.246094 C 810 613.285156 787.335938 590.621094 759.375 590.621094 Z M 759.375 590.621094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M 50.625 219.371094 L 759.375 219.371094 C 787.335938 219.371094 810 196.707031 810 168.746094 C 810 140.785156 787.335938 118.121094 759.375 118.121094 L 50.625 118.121094 C 22.664062 118.121094 0 140.785156 0 168.746094 C 0 196.707031 22.664062 219.371094 50.625 219.371094 Z M 50.625 219.371094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.c4a76e08642da313938b195b951a7834.svg";
export { ForwardRef as ReactComponent };